var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelieveryBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.412842,
    width: 37.8012,
    height: 37.8012,
    rx: 18.9006,
    fill: "#636363"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4156_11783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8558 12.0007H10.043V22.2386H21.8558V12.0007Z",
    stroke: "white",
    strokeWidth: 1.57505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8555 15.9392H25.0056L27.3681 18.3018V22.2394H21.8555V15.9392Z",
    stroke: "white",
    strokeWidth: 1.57505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5899 26.1759C14.6773 26.1759 15.5587 25.2944 15.5587 24.2071C15.5587 23.1197 14.6773 22.2383 13.5899 22.2383C12.5026 22.2383 11.6211 23.1197 11.6211 24.2071C11.6211 25.2944 12.5026 26.1759 13.5899 26.1759Z",
    stroke: "white",
    strokeWidth: 1.57505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8243 26.1759C24.9116 26.1759 25.7931 25.2944 25.7931 24.2071C25.7931 23.1197 24.9116 22.2383 23.8243 22.2383C22.7369 22.2383 21.8555 23.1197 21.8555 24.2071C21.8555 25.2944 22.7369 26.1759 23.8243 26.1759Z",
    stroke: "white",
    strokeWidth: 1.57505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4156_11783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9006,
    height: 18.9006,
    fill: "white",
    transform: "translate(9.25781 9.6377)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelieveryBus);
export default __webpack_public_path__ + "static/media/delieveryBus.3293be9b85c916a61aa29a764d61e996.svg";
export { ForwardRef as ReactComponent };